import Button from '@datacamp/waffles-button';
import { ArrowRightIcon } from '@datacamp/waffles-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const NextButton = _ref => {
  let {
    onClick
  } = _ref;
  const {
    t
  } = useTranslation('common');
  return ___EmotionJSX(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'conversational-interface-next-button'
    },
    intent: "success",
    onClick: onClick,
    size: "small"
  }, t('next'), ___EmotionJSX(ArrowRightIcon, null));
};